import { SNoop } from '@obvious.tech/util/validation/schemas'
import { defineEntity } from '../../defineEntity'
import { IImage } from '@obvious.tech/constellation'

export const Image = defineEntity('Image', {
  endpoint: 'resources/api/Image',
  schema: SNoop<IImage>(),
})
